module.exports = __webpack_public_path__ + "static/pic03-0b1ddfb91326441c194fdb0f27c4b5a8.jpg";